import React from 'react';

function Footer() {


    return (
        <>
            <footer className='footer_wrap'>
                <div className="footer_box">
                    <div className="footer_left_box">
                        <div className="footer_logo"></div> 
                        <span className='footer_left_txt'>서울특별시 강남구 테헤란로 305 한국기술센터</span>
                        <div className="footer_left_txt">TEL : 02-6009-4015, FAX : 02-6009-4019</div>
                        <div className="footer_left_txt">Email : contact@yehs.or.kr</div>
                    </div>
                    <div className="footer_right_box">
                        <div className="footer_info_box">
                            <div className="footer_info_txt_box">
                                <a href='/intro' className='footer_info_txt'><span>YEHS 소개</span></a>
                            </div>
                            <div className="footer_info_txt_box">
                                <a href='/policy' className='footer_info_txt f_bold'><span>개인정보처리방침</span></a>
                            </div>
                            <div className="footer_info_txt_box">
                                <a href='/terms' className='footer_info_txt'><span>이용약관</span></a>
                            </div>
                            <div className="footer_info_txt_box">
                                <a href='/notice' className='footer_info_txt'><span>공지사항</span></a>
                            </div>
                        </div>
                        <div className="footer_icon_box">
                            <a href="https://www.facebook.com/yehs.naek" target='_blank'  rel="noreferrer" className='footer_icon i_face'>페이스북</a>
                            <a href="https://www.youtube.com/channel/UCgvk9fEkwuWbVOK4z12_qRw"  target='_blank' rel="noreferrer" className='footer_icon i_youtube'>유튜브</a>
                            <a href="https://www.instagram.com/yehs.naek/?hl=en"  target='_blank' rel="noreferrer" className='footer_icon i_insta'>인스타그램</a>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;

